
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { useSWRInfinite } from "swr";
import ProfileSingle from "./profile-single";
import InfiniteScroll from "react-swr-infinite-scroll";
import LoaderToggle from "@/components/templateux/loading/loader-toggle";

const fetcher = (url) => fetch(url).then((res) => res.json());
const PAGE_SIZE = 6;

export default function ProfileArrayInfinite({

   itemdata
  ,placeholderdata=[]
  ,isLoading = false
  ,isError = false
  ,userdata
  ,ownerdata
  ,nodata
  ,navtype
  ,helptype
  ,sort
  ,dir
  ,swr_url=`/api/private/user/select-by-all?&sort=${sort}&dir=${dir}&q=${''}`
}) {

    const [itemdata_active,set_itemdata_active] = useState(itemdata)
    const [data_loaded,set_data_loaded] = useState(false)


    //swr infinite stuff
    const swr = useSWRInfinite((index) =>
      `${swr_url}&page=${index + 1}`,
    fetcher);

    const { data, error, mutate, size, setSize, isValidating } = swr;
    const items = data ? [].concat(...data) : itemdata_active ;
    
    const isLoadingInitialData = !items;
    const isLoadingMore = isLoadingInitialData || (size > 0 && data && typeof data[size - 1] === "undefined");
    const isEmpty = data?.[0]?.length === 0;
    const isReachingEnd = isEmpty || (data && data[data.length - 1]?.length < PAGE_SIZE);
    const isRefreshing = isValidating && data && data.length === size;

    const router = useRouter();

    useEffect(()=> {
      if (!data_loaded && data) {
        set_itemdata_active(data);
        set_data_loaded(true)
      }
    },[
      data_loaded,
      data
    ])

  if (isError) {
    return <div className="px-4">Something went wrong...</div>;
  }

  return (
    <>


      {(!isLoading && !isError && 
      (!itemdata_active || (itemdata_active && itemdata_active?.length == 0))) &&
      <div className="w-full px-4 py-5 mt-3 text-md text-center  text-white font-bold">
        {nodata}
      </div>
      }

      
        
      {(!isLoading && !isError && 
      (!itemdata_active || (itemdata_active && itemdata_active?.length > 0))) &&
      <div className=" ">
        
        {/* {isEmpty ? <p>{nodata}</p> : null} */}
        
        <InfiniteScroll
            swr={swr}
            loadingIndicator={<></>}
            endingIndicator={<div className="text-center my-5 italic">
                                <div>
                                {nodata}
                                </div>
                                <div className="flex justify-center my-4">
                                    <div
                                        onClick={() => {
                                          document.body.scrollTop = 0; // For Safari
                                          document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                                        }}
                                        className="cursor-pointer bg-blue-600 text-white font-bold px-8 py-3  rounded-full"
                                    >
                                    Back to Top
                                    </div>
                                </div>
                              </div>}
            // isReachingEnd={(swr) =>
            //   swr[0]?.length === 0 || swr[swr?.length - 1]?.length < PAGE_SIZE
            // }
            isReachingEnd={isReachingEnd}
          > 



      {items?.map((e,index) => 
      <div key={index} className="border-b  border-gray-700">
        <ProfileSingle
                itemdata={e}
                userdata={userdata}
                shrink={true}
                ownerdata={e}
                owner_block_json={e?.block_json}
                owner_name={e?.user_name}
                owner_id={e?.id}
                owner_bol_staff_help={e?.bol_staff_help}
                owner_staff_json={e?.staff_json}
                owner_bol_admin_help={e?.bol_admin_help}
                placeholder={false}
                navtype={navtype}
                helptype={helptype}
                startPlayer={()=>{}}
                isProfileHeader={false}
                
            />
        </div>
      )}
      </InfiniteScroll>
      </div>
    }

     {!isReachingEnd &&
    <div className="flex justify-center my-4">
        <div
            onClick={() => {
                if (!isLoadingMore && !isReachingEnd) setSize(size + 1)
            }}
            className="cursor-pointer border border-gray-600 text-white font-bold px-8 py-3  rounded-full"
        >
          <LoaderToggle
            loadingstate={isLoadingMore}
            actionText={'load more'}
            actionTextShort={'load more'}
            loadingClass='animate-pulse text-gray-400 w-5 h-5'
            toggle={{
                bgColor: 'transparent',
                centerColor: 'transparent',
                holeColor: 'transparent',
                pointerColor: '#ffffff',
                dialerColor: '#ffffff77',
            }}
          />
        </div>
    </div>
    }

      </>
    );
  }



